import { Grid } from "@mui/material";

import Table from "./Table";
import Graph from "./Graph";

import APIConnectedEntity from "../../../types/APIConnectedEntity";
import WebOnly from "../../WebOnly";
import ErrorBoundary from "../../ErrorBoundary";

export interface Props {
  connectedEntities: APIConnectedEntity[];
  rootEntityNameOrDomain: string;
}

export default function ConnectedEntities({
  connectedEntities,
  rootEntityNameOrDomain,
}: Props) {
  return (
    <Grid container spacing={2}>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <WebOnly>
          <ErrorBoundary>
            <Graph
              connectedEntities={connectedEntities}
              rootEntityNameOrDomain={rootEntityNameOrDomain}
            />
          </ErrorBoundary>
        </WebOnly>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <ErrorBoundary>
          <Table connectedEntities={connectedEntities} />
        </ErrorBoundary>
      </Grid>
    </Grid>
  );
}
